import data from '../assets/suggestions/data.json';

export class SuggestionDataRegistry {

    public static hasQuestionIcons(id: string | number): boolean {
        return this.data.icons.hasOwnProperty(id + '');
    }

    public static getQuestionData(id: string | number, type: 'icons'|'text'): any {
        return this.data[type][id + ''];
    }

    public static getIconFullPath(iconName: string): string {
        return '/static/suggestions/' + iconName;
    }

    public static hasQuestionSuggestionText(id: string | number): boolean {
        return this.data.text.hasOwnProperty(id + '');
    }

    private static data: any = data;
}
